/**
 * Documentation Service
 * Loads markdown documentation files
 */

const DOCUMENTATION_FILES = {
  summary: '/docs/PROJECT_PROGRESS_SUMMARY.md',
  architecture: '/docs/TELEHEALTH_PLATFORM_ARCHITECTURE.md',
  roadmap: '/docs/IMPLEMENTATION_ROADMAP.md',
  issues: '/docs/PRODUCTION_ISSUES_TRACKER.md',
  pricing: '/docs/Price_Validation_and_Scope_Agreement.md',
};

export const loadDocumentation = async (docId) => {
  try {
    const filePath = DOCUMENTATION_FILES[docId];
    if (!filePath) {
      throw new Error(`Documentation file not found: ${docId}`);
    }

    // Try to fetch from public/docs directory first
    const response = await fetch(filePath);
    if (response.ok) {
      return await response.text();
    }

    // Fallback: Try to fetch from root (if files are in public root)
    const rootResponse = await fetch(`/${docId === 'architecture' ? 'TELEHEALTH_PLATFORM_ARCHITECTURE' : docId === 'roadmap' ? 'IMPLEMENTATION_ROADMAP' : 'PRODUCTION_ISSUES_TRACKER'}.md`);
    if (rootResponse.ok) {
      return await rootResponse.text();
    }

    throw new Error(`Failed to load documentation: ${docId}`);
  } catch (error) {
    console.error('Error loading documentation:', error);
    // Return a placeholder message
    return `# Documentation Loading Error\n\nUnable to load ${docId}. Please ensure the documentation files are available.\n\n**Error:** ${error.message}`;
  }
};

export const getAllDocumentationIds = () => Object.keys(DOCUMENTATION_FILES);

